import type { WorkArrangements } from '@talentmesh/utils';
import React from 'react';
import { useWatch } from 'react-hook-form';

import { TypographyH4, TypographyP } from '@/Components/shadcn/typography';
import UIStrings from '@/Utils/UIStrings';
import { JobDetailsFieldTypes } from '../../JobDetailsStepUtils';

function JobLocationTooltipBody(): React.JSX.Element {
    const workArrangement: WorkArrangements = useWatch({ name: JobDetailsFieldTypes.WorkArrangement });

    return (
        <div className="flex max-w-sm flex-col gap-2">
            <TypographyH4 className="text-foreground">
                {workArrangement === 'Remote' ? UIStrings.RemoteTooltipTitle : UIStrings.OnLocationTooltipTitle}
            </TypographyH4>
            <TypographyP className="text-foreground">
                {workArrangement === 'Remote'
                    ? UIStrings.RemoteTooltipDescription
                    : UIStrings.OnLocationTooltipDescription}
            </TypographyP>
        </div>
    );
}

export default JobLocationTooltipBody;
